<template>
  <v-menu
    left
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon>more_vert</v-icon>
      </v-btn>
    </template>

    <v-list dense>
      <event-group-create-update-dialog
        :event-group="eventGroup"
        :event-id="eventId"
      >
        <template v-slot:activator="{ on }">
          <v-list-item
            v-on="on"
            @click.stop=""
          >
            <v-list-item-content>
              <v-list-item-title>
                <v-icon left>
                  edit
                </v-icon>
                Edit
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </event-group-create-update-dialog>

      <event-item-create-update-dialog
        :event-id="eventId"
        :event-group-id="eventGroup.id"
      >
        <template v-slot:activator="{ on }">
          <v-list-item
            v-on="on"
            @click.stop=""
          >
            <v-list-item-content>
              <v-list-item-title>
                <v-icon left>
                  add
                </v-icon>
                Add Event Item
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </event-item-create-update-dialog>

      <event-group-complete-event-dialog
        v-if="_isEmpty(eventGroup.completeEvent)"
        :event-group-id="eventGroup.id"
      >
        <template v-slot:activator="{ on }">
          <v-list-item
            v-on="on"
            @click.stop=""
          >
            <v-list-item-content>
              <v-list-item-title>
                <v-icon left>
                  add
                </v-icon>
                Add Completion Event
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </event-group-complete-event-dialog>

      <v-list-item
        :disabled="isDeleteDisabled"
        @click.stop="confirmDelete = true"
      >
        <v-list-item-content>
          <v-list-item-title>
            <v-icon
              :color="isDeleteDisabled ? '' : 'error'"
              :disabled="isDeleteDisabled"
              left
              small
            >
              delete
            </v-icon>
            <span :class="isDeleteDisabled ? '' : 'error--text'">Delete</span>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <confirm-action
      :model="confirmDelete"
      :color="'error'"
      :title="'Delete Group'"
      :description="'Are you sure you want to delete this event group?'"
      :action-text="'Delete'"
      @cancel="confirmDelete = false"
      @confirmed="confirmed"
    />
  </v-menu>
</template>
<script>
import { isEmpty } from 'lodash'
import { mapActions } from 'vuex'
import EventGroupCreateUpdateDialog from "../../EventGroup/EventGroupCreateUpdateDialog"
import EventGroupCompleteEventDialog from "../../EventGroup/EventGroupCompleteEventDialog"
import EventItemCreateUpdateDialog from "../../EventItem/EventItemCreateUpdateDialog"
import ConfirmAction from "../../Common/ConfirmAction"

export default {
  components: {
    ConfirmAction,
    EventItemCreateUpdateDialog,
    EventGroupCreateUpdateDialog,
    EventGroupCompleteEventDialog
  },
  props: {
    eventGroup: {
      type: Object,
      default: () => ({})
    },
    eventId: {
      type: String,
      required: true,
      default: ''
    },
    numChildren: {
      type: Number,
      required: true,
      default: 0
    }
  },
  data() {
    return {
      confirmDelete: false,
    }
  },
  computed: {
    isDeleteDisabled() {
      return this.numChildren > 0
    }
  },
  methods: {
    ...mapActions([ 'deleteEventGroup' ]),
    _isEmpty: (val) => isEmpty(val),
    async confirmed() {
      const payload = {
        id: this.eventGroup.id
      }
      await this.deleteEventGroup(payload)
      this.confirmDelete = false
    }
  }
}
</script>
